<script type="text/javascript">
import RichTextEditor from "../../global/form/RichTextEditor";
import SendableTags from "Components/settings/sendables/SendableTags";
import { http } from '@/system/http';
import Spinner from 'Components/login/Spinner.vue';
import EpBanner from 'Components/global/banner/index.vue';
import GsmHelper from '@/system/helpers/GSMValidator';

const domParser = new DOMParser();
const gsmHelper = new GsmHelper();

export default {
    data() {
        return {
            sendable_content: this.value,
            editor: null,
            exampleContentHtml: '',
            textEditorConfig: {
                toolbar: [],
                mention: {
                    feeds: [
                        {
                            marker: '@',
                            feed: [],
                            itemRenderer: this.customItemRenderer,
                            minimumCharacters: 0
                        }
                    ]
                }
            },
        }
    },

    props: {
        value: {
            required: true
        },
        simple: {
            default: false
        },
    },

    computed: {
        owner() {
            return this.$store.state.auth.owner;
        },

        sms_price() {
            const price = this.$store.state.auth.owner.sms_price_standard
            return Config.get('countries.' + this.owner.country + '.subscription_currency') + " " + format_amount(price / 100, 2);
        },

        sms_price_international() {
            const price = this.$store.state.auth.owner.sms_price_international
            return Config.get('countries.' + this.owner.country + '.subscription_currency') + " " + format_amount(price / 100, 2);
        },

        exampleContentText() {
            const document = domParser.parseFromString(this.exampleContentHtml, 'text/html');

            // Look specifically for the SMS message content in the .message element
            const messageElement = document.querySelector('.sms-example-message .message');
            if (messageElement) {
                return messageElement.textContent.trim();
            }

            // Fallback to body text if .message element not found
            return document.body ? document.body.textContent.trim() : '';
        },

        messageAnalysisResult() {
            return gsmHelper.analyzeText(this.exampleContentText);
        },

        messageCount() {
            return gsmHelper.getSmsCount(this.exampleContentText);
        },

        messageCountText() {
            return transChoice('messages.message_count', this.messageCount, {
                count: this.messageCount,
                chars: this.messageAnalysisResult.length,
            });
        },

        available_tags() {
            return this.$store.getters['sendables/getAvailableTags'];
        },
    },

    mounted() {
        this.textEditorConfig.mention.feeds[0].feed = this.available_tags;
        this.getExampleContentHtml();
    },

    methods: {

        insertTag(tag) {
            this.editor.execute('mention', {marker: '@', mention: tag.id});
            this.editor.focus();
        },

        bindEditor(editor) {
            this.editor = editor;
        },

        customItemRenderer(item) {
            const itemElement = document.createElement('button');

            itemElement.textContent = `${item.description} `;

            itemElement.classList.add('custom-item');
            itemElement.id = `mention-list-item-id-${item.userId}`;
            itemElement.textContent = `${item.description} `;

            const usernameElement = document.createElement('span');

            usernameElement.classList.add('text-muted');
            usernameElement.textContent = item.id;

            itemElement.appendChild(usernameElement);

            return itemElement;
        },

        async getExampleContentHtml() {
            const params = {
                id: this.sendable_content.id ?? null,
                channel: 'sms',
                content: this.sendable_content.content
            };

            const { data } = await http.get('/app/settings/sendables/content/example', { params })
                .catch((error) => {
                    return '';
                });

            this.exampleContentHtml = data;
        },
    },

    watch: {
        sendable_content: {
            handler(newVal) {
                this.$emit('input', newVal);
                this.getExampleContentHtml();
            },
            deep: true,
        }
    },

    components: {
        EpBanner,
        Spinner,
        RichTextEditor,
        SendableTags,
    },
};
</script>

<template id="sendable-sms-input">
    <div class="row">
        <div class="col-xs-12" :class="{ 'col-sm-7' : !simple }">
            <div class="form-group">
                <label for="" class="control-label">{{ trans('sendables.content') }}</label>

                <div class="sendable-sms-input m-b-10">
                    <rich-text-editor
                        :id="'sms-input-' + _uid"
                        name="content-input"
                        :resizable="false"
                        v-model="sendable_content.content"
                        height="250px"
                        :config="textEditorConfig"
                        @ready="bindEditor"
                    ></rich-text-editor>

                    <small class="m-0 text-muted m-t-0">
                        <ep-banner v-if="!messageAnalysisResult.isGsmCompatible" variant="warning" class="mt-5">
                            {{ trans('messages.non_gsm_format_warning') }}
                        </ep-banner>

                        {{ messageCountText }}
                        <span v-tooltip="trans('subscription.sms_price', { price_1 : sms_price, price_2 : sms_price_international })">
                            <i class="zmdi zmdi-info"></i>
                        </span>
                    </small>
                </div>
            </div>

            <div class="form-group" v-if="this.sendable_content.content !== ''">
                <label for="" class="control-label truncate">{{ trans('sendables.example') }}</label>

                <iframe
                    :srcdoc="exampleContentHtml"
                    :style="{ 'border-style' : 'none', 'width' : '100%', 'height' : '120px'}">
                </iframe>
            </div>
        </div>

        <div class="col-xs-12 col-sm-5" v-if="!simple">
            <sendable-tags @insertTag="insertTag"></sendable-tags>

            <slot></slot>
        </div>
    </div>
</template>
